<template lang="html">

    <section class="game-list">
        <section v-if="headlines && headlines.length > 0">
            <section v-bind:key="headline.name" v-for="headline in headlines">
                <section v-if="headline.games && headline.games.data && headline.games.data.length > 0">
                    <v-row style="position: relative" class="my-0">
                        <v-col cols="10" class="pb-1">
                            <router-link v-if="type === 'user'" :to="{ name: 'user', params: { id: headline.id }}">
                                <a>
                                    <h1 class="mt-5">{{headline.name}}</h1>
                                </a>
                            </router-link>
                            <h1 class="mt-5" v-else>{{headline.name}}</h1>
                        </v-col>
                        <v-col cols="2" id="more_games" class="pb-1" v-if="showMore">
                            <router-link :to="{ name: 'allGames', params: { type: type, id: headline.id, user: user} }">
                                <a>
                                    More
                                </a>
                            </router-link>
                        </v-col>
                    </v-row>
                    <v-divider class="mb-3"></v-divider>
                    <v-row>
                        <div class="vertical_scroll">
                            <table class="table">
                                <tr v-if="headline.games">
                                    <td v-bind:key="headline.name + '_' + game.name.en + '_' + index" v-for="(game, index) in headline.games.data">
                                        <v-hover v-slot:default="{ hover }">
                                            <v-card height="300" width="200" class="game_card" hover
                                                    :img="(game.picture_path.includes('http')) ? game.picture_path : thumb_url + game.picture_path" @click.self="() => {$router.push({ name: 'game', params: { slug: game.slug }})}">
                                              <v-fade-transition>
                                                    <router-link :to="{ name: 'game', params: { slug: game.slug } }">
<!--                                                        <v-card-title v-if="hover && game.name.de" class="game_card_title">{{game.name.de}}-->
<!--                                                        </v-card-title>-->
                                                      <v-card-title v-if="hover" class="game_card_title">
                                                        <span v-if="typeof  game.name.en === 'undefined'">{{ JSON.parse(game.name).en }}</span>
                                                        <span v-else>{{ game.name.en }}</span>
                                                      </v-card-title>
                                                    </router-link>
                                                </v-fade-transition>
                                                <v-fade-transition @click.stop>
                                                    <v-rating v-if="hover && voteable" class="game_rating onhover"
                                                              half-increments hover
                                                              v-model="game.user_rating" :readonly="!voteable"
                                                              :color="voteable ? 'primary' : 'white'"
                                                              background-color="grey"
                                                              @input="rate($event, game)"
                                                              @click.stop></v-rating>
                                                </v-fade-transition>
                                            </v-card>
                                        </v-hover>
                                        <v-rating v-if="showRating && showUserRating" class="game_average_rating" v-model="game.user_rating"
                                                  half-increments readonly dense background-color="background"
                                                  small color="primary"></v-rating>
                                        <v-rating v-if="showRating && !showUserRating" class="game_average_rating" v-model="game.rating"
                                                  half-increments readonly dense background-color="background"
                                                  small color="white"></v-rating>
                                        <v-row class="ml-1 mt-0" v-if="type === 'recently'">
                                            <v-col cols="2" class="mt-0 pt-0">
                                                <v-avatar size="20" v-if="game.user_picture_path" class="avatar">
                                                    <img :src="profile_pic_url + game.user_picture_path" alt="Profilbild"/>
                                                 </v-avatar>
                                                <v-avatar size="20" v-else class="avatar">
                                                    <v-icon class="avatar_default">mdi-account</v-icon>
                                                </v-avatar>
                                            </v-col>
                                            <v-col class="float-left mt-0 pt-0">
                                                <p>{{ game.username }}</p>
                                            </v-col>
                                        </v-row>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </v-row>
                </section>
                <section v-else-if="headline.loaded">
                    <v-row style="position: relative">
                        <v-col cols="10" class="pb-1">
                            <router-link v-if="type === 'user'" :to="{ name: 'user', params: { id: headline.id }}">
                                <a>
                                    <h1 class="mt-5">{{headline.name}}</h1>
                                </a>
                            </router-link>
                            <h1 class="mt-5" v-else>{{headline.name}}</h1>
                        </v-col>
                    </v-row>
                    <v-divider class="mb-3"></v-divider>
                    <v-row>
                        <v-col cols="12">
                            <v-card v-if="type === 'user'">
                                <v-card-title>This user has not rated a game yet!</v-card-title>
                            </v-card>
                            <v-card v-else>
                                <v-card-title>There are no games here yet!</v-card-title>
                            </v-card>
                        </v-col>
                    </v-row>
                </section>
            </section>
        </section>
        <section v-else-if="headlines.loaded && headlines.length === 0">
            <v-card v-if="type === 'user'">
                <v-card-title>Nothing to see here yet!</v-card-title>
                <v-card-subtitle>Add a user as a friend to see their games here</v-card-subtitle>
            </v-card>
            <v-card v-else>
                <v-card-title>There is nothing to see here yet!</v-card-title>
            </v-card>
        </section>
    </section>

</template>

<script lang="js">
    import GameService from "../../services/GameService";

    export default {
        name:       'game-list',
        props:      ['headlines', 'voteable', 'showRating', 'showUserRating', 'showMore', 'type', 'user'],
        components: {},
        mounted () {

        },
        data () {
            return {
                'thumb_url': window.api_url + "/storage/image/game/thumb_",
                'profile_pic_url': window.api_url + "/storage/image/user/",
                'genres':    [],
            }
        },
        methods:    {
            rating (rating) {
                return rating ? parseFloat(rating) : 0
            },
            rate (value, game) {
                if (this.user) {
                    GameService.rate(game.id, value)
                               .then(res => {

                                   game.rating = res.data.average;
                               })
                               .catch(() => {

                               });
                } else {
                    this.$router.push('/login');
                }
            },

        },
        watch:      {}
    }


</script>

<style lang="scss">
    a {
        text-decoration: none;
    }

    .game-list {

    }

    .game_card {
        margin: 10px;
        position: relative;
        cursor: default;
    }

    .game_card:hover {
        box-shadow: inset 0px 60px 30px -10px rgba(0, 0, 0, 0.6),
        inset 0px -60px 30px -10px rgba(0, 0, 0, 0.6) !important;
    }


    .game_card_title {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        display: block !important;
    }

    .game_rating {
        position: absolute;
        bottom: 0;
    }

    .game_rating .v-icon {
      width: 40px;
    }

    .game_average_rating {
        margin-left: 10px;
    }

    .vertical_scroll {
        display: block;
        width: 100%;
        overflow-x: auto;
        overflow-y: hidden
    }

    #more_games {
        position: absolute;
        right: 0;
        bottom: 0;
        text-align: right;
    }


</style>
